import { mutations } from "@/constants/state";

export default {
  [mutations.HRNOTIFICATIONS_FETCH_MUTATION]: (state, payload) => {
    state.hrNotifications = payload;
  },
};
